import { Group, Ctrl } from '@/components/control-panl'
import { DataSetAtom, ModelRaw } from '@/store'
import { ui18n } from '@/lang'

export const ctrolGroup = [
    {
        ctrls: [{ icon: 'add', value: 'add', inClick: true, desc: ui18n.t('dataset.join') }],
    },
    {
        apart: true,
        ctrls: [{ icon: 'uploading', value: 'upload', desc: ui18n.t('dataset.upload'), inClick: true }],
    },
]

export type CtrlAtom = typeof ctrolGroup extends Group<infer P> ? P : never
export type SelectArgs = { dataset: DataSetAtom; models: ModelRaw }

export type PropressProp = { id: string; name: string; setp: number }
